import { createContext } from "react";
const ChatbotDataContext = createContext({});
export { ChatbotDataContext };
